import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { RoleGuard } from './core/auth/guards/role.guard';
import { dealerIntDataResolver } from './modules/dealer/dealer.resolvers';
import { corporateIntDataResolver } from './modules/corporate/corporate.resolvers';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to respective dashboard
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Redirect signed-in user to the '/dashboard'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'dashboard' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: 'otp-input', loadChildren: () => import('app/modules/auth/otp-input/otp-input.routes') },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') }
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes') },
        ]
    },

    // User/subscriber routes
    {
        path: '',
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        component: LayoutComponent,
        data: {
            roles: ['USER']
        },
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.routes') },
            { path: 'genealogy-tree', loadChildren: () => import('app/modules/admin/genealogy-tree/genealogy-tree.routes') },
            { path: 'reports', loadChildren: () => import('app/modules/admin/reports/reports.routes') },
            { path: 'campaign', loadChildren: () => import('app/modules/admin/campaign/campaign.routes') },
            // { path: 'sim-upline-tagging', loadChildren: () => import('app/modules/admin/sim-upline-tagging/sim-upline-tagging.routes') },
        ]
    },

    // Dealer routes
    {
        path: '',
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        component: LayoutComponent,
        data: {
            roles: ['DEALER']
        },
        resolve: {
            dealerInitData: dealerIntDataResolver
        },
        children: [
            { path: 'dealer/dashboard', loadChildren: () => import('app/modules/dealer/dealer-dashboard/dealer-dashboard.routes') },
            { path: 'dealer/corporates', loadChildren: () => import('app/modules/dealer/corporates/corporates.routes') },
            { path: 'dealer/corporate/register', loadChildren: () => import('app/modules/dealer/corporates/create-corporate/create-corporate.routes') },
            { path: 'dealer/ewallet', loadChildren: () => import('app/modules/dealer/ewallet/ewallet.routes') },
            // { path: 'dealer/topup-msisdn', loadChildren: () => import('app/modules/dealer/topup-msisdn/topup-msisdn.routes') },
            { path: 'dealer/register-subscriber', loadChildren: () => import('app/modules/dealer/add-msisdn/add-msisdn.routes') },
            { path: 'dealer/subscribers', loadChildren: () => import('app/modules/dealer/corporate-subscribers/corporate-subscribers.routes') },
        ]

    },

    // Business/Corporate routes
    {
        path: '',
        canActivate: [AuthGuard, RoleGuard],
        canActivateChild: [AuthGuard, RoleGuard],
        component: LayoutComponent,
        data: {
            roles: ['BUSINESS']
        },
        resolve: {
            corpInitData: corporateIntDataResolver
        },
        children: [
            { path: 'corporate/dashboard', loadChildren: () => import('app/modules/corporate/corporate-dashboard/corporate-dashboard.routes') },
            { path: 'corporate/subscribers', loadChildren: () => import('app/modules/corporate/corporate-subscribers/corporate-subscribers.routes') },
            { path: 'corporate/topup-msisdn', loadChildren: () => import('app/modules/corporate/topup-msisdn/topup-msisdn.routes') },
            { path: 'corporate/plans', loadChildren: () => import('app/modules/corporate/plans/plans.routes') },
            { path: 'corporate/account', loadChildren: () => import('app/modules/corporate/account/account.routes') },
        ]

    }



];
